import styled from "@emotion/styled";
import { pxToRem } from "@src/utils";

const StyledForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  padding: ${pxToRem(20)};
  margin-bottom: 44px;
`;

const StyledImage = styled.img`
  width: 100%;
`;

export { StyledForm, StyledImage };
